import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=038f4b26&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038f4b26')) {
      api.createRecord('038f4b26', component.options)
    } else {
      api.reload('038f4b26', component.options)
    }
    module.hot.accept("./Join.vue?vue&type=template&id=038f4b26&", function () {
      api.rerender('038f4b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/auth/Join.vue"
export default component.exports